import { useState } from 'react'
import { useAdmin } from '../../context/AdminContext'
import AdminLogin from './AdminLogin'
import AdminDashboard from './AdminDashboard'

export default function AdminPage() {
  const { isAdmin } = useAdmin()
  const [view, setView] = useState(isAdmin ? 'dashboard' : 'login')

  if (view === 'dashboard' && isAdmin) {
    return <AdminDashboard onLogout={() => setView('login')} />
  }

  return <AdminLogin onSuccess={() => setView('dashboard')} />
}
